module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_balsthal-44dcf5483a7117d0527780ebef4b7092.png";